import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, LOGO_URL } from "../lib/api";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import { Button } from "../components/ui/button";
import { toast } from "sonner";
import { Loader2, LockKeyhole } from "lucide-react";

export default function AdminLoginPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      localStorage.setItem("mybeema_token", data.access_token);
      localStorage.setItem("mybeema_user", JSON.stringify(data.user));
      toast.success("Welcome back, Admin");
      navigate("/admin");
    } catch (err) {
      const msg = err?.response?.data?.detail || "Login failed";
      toast.error(typeof msg === "string" ? msg : "Login failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#F8F9FA] flex items-center justify-center px-6 py-12" data-testid="admin-login-page">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <img src={LOGO_URL} alt="MY BEEMA" className="h-16 w-16 rounded-full object-cover mx-auto ring-2 ring-[#006A4E]/20" />
          <div className="font-display text-2xl font-bold mt-4 text-[#0B192C]">MY BEEMA<span className="text-[#006A4E]">.in</span></div>
          <div className="text-[10px] uppercase tracking-[0.25em] text-[#4A5568] mt-1">Admin Console</div>
        </div>

        <div className="bg-white rounded-2xl border border-[#E2E8F0] shadow-[0_18px_40px_-20px_rgba(11,25,44,0.18)] p-8">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-10 h-10 rounded-lg bg-[#E6F0ED] flex items-center justify-center">
              <LockKeyhole className="w-5 h-5 text-[#006A4E]" strokeWidth={1.5} />
            </div>
            <div>
              <h1 className="font-display text-xl text-[#0B192C]">Welcome back</h1>
              <p className="text-xs text-[#4A5568]">Sign in to manage enquiries</p>
            </div>
          </div>

          <form onSubmit={submit} className="space-y-5">
            <div>
              <Label htmlFor="email" className="text-xs uppercase tracking-wider">Email</Label>
              <Input id="email" data-testid="admin-login-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className="mt-1.5 rounded-lg" placeholder="support@mybeema.in" />
            </div>
            <div>
              <Label htmlFor="password" className="text-xs uppercase tracking-wider">Password</Label>
              <Input id="password" data-testid="admin-login-password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className="mt-1.5 rounded-lg" placeholder="••••••••" />
            </div>
            <Button
              type="submit"
              data-testid="admin-login-submit-btn"
              disabled={loading}
              className="w-full rounded-full bg-[#006A4E] hover:bg-[#00523C] text-white py-6 font-semibold shadow-md hover:shadow-lg hover:-translate-y-0.5 transition-all"
            >
              {loading ? (<><Loader2 className="w-4 h-4 mr-2 animate-spin" />Signing in…</>) : "Sign In"}
            </Button>
          </form>
        </div>

        <p className="text-xs text-center text-[#4A5568] mt-6">
          ← <a href="/" className="hover:text-[#006A4E]" data-testid="admin-back-home">Back to home</a>
        </p>
      </div>
    </div>
  );
}
